import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminLogin = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, form);
      localStorage.setItem("feral_admin_token", data.token);
      localStorage.setItem("feral_admin_user", JSON.stringify(data.user));
      navigate("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#1c3c38] feral-texture-dark flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md bg-white rounded-lg shadow-2xl p-8 md:p-10">
        <div className="text-center mb-8">
          <div className="w-14 h-14 rounded-full bg-[#9b3d0a] flex items-center justify-center mx-auto mb-4">
            <Lock size={24} className="text-white" />
          </div>
          <h1 className="feral-serif text-[#9b3d0a] text-3xl">FERAL Admin</h1>
          <p className="text-[#6e5646] text-sm mt-1">Team dashboard — sign in to continue</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-[#1e231f] mb-1.5">Email</label>
            <input
              type="email"
              data-testid="admin-email-input"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="w-full bg-white border border-[#d9c3a8] px-4 py-2.5 rounded-sm outline-none focus:ring-2 focus:ring-[#ce8a39] text-[#1e231f]"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-[#1e231f] mb-1.5">Password</label>
            <input
              type="password"
              data-testid="admin-password-input"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              className="w-full bg-white border border-[#d9c3a8] px-4 py-2.5 rounded-sm outline-none focus:ring-2 focus:ring-[#ce8a39] text-[#1e231f]"
            />
          </div>
          {error && (
            <p className="text-[#9b3d0a] text-sm bg-[#f3e7d6] border border-[#e0c9ad] rounded px-3 py-2" data-testid="admin-login-error">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-button"
            className="w-full bg-[#9b3d0a] hover:bg-[#7e3208] disabled:opacity-60 text-white py-3 rounded-full tracking-[0.12em] text-sm font-semibold transition-colors"
          >
            {loading ? "SIGNING IN…" : "SIGN IN"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
